import React, { useEffect, useState } from 'react'
import GA from '../../GoogleAnalytics';
import { Coleccion } from '../../Components/Coleccion';
import Loader from '../../Components/Loader';
import { Button } from '../../Components/Button';
import SearchComponent from '../../Components/Search';
import TematicoService, {iTematico} from '../../Services/TematicoService';
import './index.scss'

export const Home = () => {
    const [listColeccion, setListColeccion ] = useState<iTematico[]>([]);
    const [ showSearch , setShowSearch ] = useState(false);
    const [ isLoading , setIsLoading ] = useState(false);

    function closeSearch () {
        setShowSearch(false);
    }

    useEffect(() =>{
        setIsLoading(true);
        TematicoService.getAll().then( ({ data }: any) =>{
            setListColeccion(data.data)
        }).finally(
            setIsLoading(false)
        )
    },[])

    return (
        <div className="p_home">
            <GA.RouteTracker title={"Archivo Digital de Arte Peruano"}/>
            <div className="p_home__head">
                <h2 className="e-h1 p_home__title">ARCHIVO <br></br> DIGITAL DE <br></br> ARTE PERUANO</h2>
                <div className="p_home__head_right">
                    <div className="p_home__partners">
                        <div className="your-loader"></div>
                        <h6 className="e-text-light e-p3">PATROCINADORES</h6>
                        <div className="p_hpme__partners_list">
                            <img src="./images/irradia.png"></img>
                            <img src="./images/AF_EFT_Logo.png"></img>
                            <img src="./images/Logo-FT-Movistar.png"></img>
                            <img src="./images/logo-ministerio-cultura.png"></img>
                            <img src="./images/embajada-suiza.png"></img>
                        </div>
                    </div>
                    <div className="p_home__buttons">
                        <Button action={()=>{setShowSearch(true)}} theme="solid">
                            BUSCAR RECURSOS
                        </Button>
                        <Button theme="linear">
                            RECURSOS PEDAGOGICOS
                        </Button>
                    </div>
                </div>
            </div>
            { isLoading ?
                <Loader/>
                    :
                    <div className="p_home__coleccion_grid">
                        {listColeccion && listColeccion.length > 0 &&
                            listColeccion.map( (item: iTematico, index: number) => {
                                return (<Coleccion 
                                            isSecondary={ index % 2 == 0 } 
                                            key={index}
                                            title={item.nombre}
                                            banner={item.portada}
                                        ></Coleccion>)
                            })
                        }
                    </div>
            }
            { showSearch &&
                <SearchComponent handleClose={closeSearch}/>
            }
        </div>
    )
}